import { useGlobalContext } from '@/context/Global/GlobalContext';
import { useIsMobile } from '@/utils/isMobile';
import { Drawer } from '@mui/material';
import { SideBarMenu } from './Menu';

export default function SideNav() {
  const isMobile = useIsMobile();
  const { sideMenuOpened, setSideMenuOpened } = useGlobalContext();

  return (
    <>
      {isMobile ? (
        <Drawer
          open={sideMenuOpened}
          onClose={() => setSideMenuOpened?.(false)}
        >
          <SideBarMenu />
        </Drawer>
      ) : (
        <SideBarMenu />
      )}
    </>
  );
}
